import React, { createContext, useContext, ReactNode } from "react";
import { UseFormReturn } from "react-hook-form";
import { ActivityOption } from "$utils/typeConstants";
import { User } from "$types/User";

type UserFormContextType = {
  form: UseFormReturn<User>;
  isCoordinator: boolean;
  canBeUser: boolean;
  hasToBeUser: boolean;
  canHaveTwoPhones: boolean;
  canBeApprover: boolean;
  activitiesOptions?: ActivityOption[];
  error?: string;
  isSubmitting: boolean;
};

const UserFormContext = createContext<UserFormContextType | undefined>(
  undefined
);

export const UserFormProvider: React.FC<{
  children: ReactNode;
  value: UserFormContextType;
}> = ({ children, value }) => {
  return (
    <UserFormContext.Provider value={value}>
      {children}
    </UserFormContext.Provider>
  );
};

export const useUserFormContext = () => {
  const context = useContext(UserFormContext);
  if (!context) {
    throw new Error("useUserFormContext must be used within UserFormProvider");
  }
  return context;
};
